import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.event
 * @constructor
 */
export class EventModel extends BaseModel {
  /**
   * @param {string} id
   * @param {string} eventType
   * @param {number} sequenceId
   * @param {Date} createdAt
   * @param {string} resourceId
   * @param {string} resourceType
   * @param {Object} [previousValues]
   * @param {loavies.models.event.EventAuditDataModel} auditData
   */
  constructor({
    id,
    eventType,
    sequenceId,
    createdAt,
    resourceId,
    resourceType,
    previousValues,
    auditData,
  }) {
    super()

    /** @type {string} */
    this.id = id

    /** @type {string} */
    this.eventType = eventType

    /** @type {number} */
    this.sequenceId = sequenceId

    /** @type {Date} */
    this.createdAt = createdAt

    /** @type {string} */
    this.resourceId = resourceId

    /** @type {string} */
    this.resourceType = resourceType

    /** @type {undefined|Object} */
    this.previousValues = previousValues

    /** @type {loavies.models.event.EventAuditDataModel} */
    this.auditData = auditData
  }
}

export const EVENT_TYPES = {
  TRANSACTION_INITIATED: 'transaction/initiated',
  TRANSACTION_TRANSITIONED: 'transaction/transitioned',
  TRANSACTION_UPDATED: 'transaction/updated',
  TRANSACTION_DELETED: 'transaction/deleted',
}

export const RESOURCE_TYPES = {
  LISTING: 'listing',
  TRANSACTION: 'transaction',
  USER: 'user',
  REVIEW: 'review',
}
